webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return log; });
/* harmony export (immutable) */ __webpack_exports__["a"] = jsonParse;
/* unused harmony export secondToTime */
/* harmony export (immutable) */ __webpack_exports__["g"] = fullScreen;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrayElementMoveForward;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrayElementMoveBackword;
/* harmony export (immutable) */ __webpack_exports__["e"] = arrayElementMoveBegin;
/* harmony export (immutable) */ __webpack_exports__["f"] = arrayElementMoveEnd;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var log =  false ? console.log.bind(window.console) : function () {
    return '';
};


function jsonParse(string) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var json = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.attempt(JSON.parse, string);
    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isError(json)) {
        log('JSON parse fail');
        json = defaultValue;
    }
    return json;
}

function secondToTime(second) {
    if (second > 60 * 60) return '??:??';
    var timeArray = (second + '').split('.');
    var intSecond = parseInt(timeArray[0], 10);
    var microSecoond = timeArray.length > 1 ? parseInt(timeArray[1], 10) * 60 / (10 * timeArray[1].length) : 0;
    return ('0' + Math.floor(intSecond / 60)).slice(-2) + ':' + ('0' + intSecond % 60).slice(-2) + ':' + ('0' + microSecoond % 60).slice(-2);
}

function fullScreen() {
    var doc = window.document;
    var docEl = doc.documentElement;
    var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    requestFullScreen.call(docEl);
}

function arrayElementMoveForward(arr, index) {
    if (index < 0 || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveForward', 'wrong index', index);
        return arr;
    }
    var arrClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
    arrClone.splice(index, 2, arrClone[index + 1], arrClone[index]);
    return arrClone;
}

function arrayElementMoveBackword(arr, index) {
    if (index < 0 || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveBackword', 'wrong index', index);
        return arr;
    }
    var arrClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
    arrClone.splice(index - 1, 2, arrClone[index], arrClone[index - 1]);
    return arrClone;
}

function arrayElementMoveBegin(arr, index) {
    if (index < 0 || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveBegin', 'wrong index', index);
        return arr;
    }
    var arrClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
    var target = void 0;
    if (index === arrClone.length - 1) {
        target = arrClone.pop();
        return [target].concat(arrClone);
    } else {
        target = arrClone.splice(index, 1);
        return target.concat(arrClone);
    }
}

function arrayElementMoveEnd(arr, index) {
    if (index < 0 || !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(index) || index >= arr.length) {
        log('[ERR] arrayElementMoveEnd', 'wrong index', index);
        return arr;
    }
    if (index === arr.length - 1) return arr;
    var arrClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr));
    var target = arrClone.splice(index, 1);
    return arrClone.concat(target);
}

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_sign__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_list__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_project__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_app_project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_app_project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_test__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_test__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'sign',
        component: __WEBPACK_IMPORTED_MODULE_2__components_app_sign___default.a
    }, {
        path: '/list',
        name: 'list',
        component: __WEBPACK_IMPORTED_MODULE_3__components_app_list___default.a,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/project/:id',
        name: 'project',
        component: __WEBPACK_IMPORTED_MODULE_4__components_app_project___default.a,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/test',
        name: 'test',
        component: __WEBPACK_IMPORTED_MODULE_5__components_test___default.a
    }]
}));

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    firebaseConfig: {
        apiKey: 'AIzaSyA4Q_NWqw-_NVr5oNz6CzRu8fKv_J-0gLI',
        authDomain: 'music-sheet-20e93.firebaseapp.com',
        databaseURL: 'https://music-sheet-20e93.firebaseio.com',
        projectId: 'music-sheet-20e93',
        storageBucket: 'music-sheet-20e93.appspot.com',
        messagingSenderId: '1065315460721'
    },
    uploadFileMaxByte: 5000000,
    defaultSpeed: 60,
    defaultBeatPerline: 12,
    defaultCountDownBeats: 4
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(149)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(151)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_function__ = __webpack_require__(4);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    user: window.localStorage.getItem('user') ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__js_function__["a" /* jsonParse */])(window.localStorage.getItem('user')) : {
        email: 'guess'
    },
    selectProject: window.localStorage.getItem('selectProject') ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__js_function__["a" /* jsonParse */])(window.localStorage.getItem('selectProject')) : {
        projectId: null,
        projectName: null,
        record: [],
        images: []
    },
    loading: false,
    progress: 100,
    progressArray: []
};
var myPlugin = function myPlugin(store) {
    store.subscribe(function (mutation, state) {});
};
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    plugins: [myPlugin],
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__,
    strict: "production" !== 'production'
});
if (false) {
    module.hot.accept(['./getters', './actions', './mutations'], function () {
        store.hotUpdate({
            getters: require('./getters'),
            actions: require('./actions'),
            mutations: require('./mutations')
        });
    });
}
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfjs_dist__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfjs_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfjs_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_function__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_com_progress_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_com_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_com_progress_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        comProgress: __WEBPACK_IMPORTED_MODULE_5__components_com_progress_vue___default.a
    },
    data: function data() {
        return {};
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actionUploadPdfFile', 'actionUploadFileByBase64']), {
        test: function test() {},
        uploadFile: function uploadFile(e) {
            var inputFiles = e.target.files || e.dataTransfer.files;
            if (inputFiles.length) {
                var files = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(inputFiles);
                this.actionUploadPdfFile({
                    file: files[0]
                }).then(function (url) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_function__["b" /* log */])('url', url);
                    __WEBPACK_IMPORTED_MODULE_2_pdfjs_dist___default.a.disableWorker = true;

                    __WEBPACK_IMPORTED_MODULE_2_pdfjs_dist___default.a.getDocument(url).then(function (pdf) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_function__["b" /* log */])(pdf.numPages);

                        pdf.getPage(1).then(function (page) {
                            var scale = 1.5;
                            var viewport = page.getViewport(scale);
                            var canvas = document.createElement("canvas");
                            var context = canvas.getContext('2d');
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;
                            page.render({ canvasContext: context, viewport: viewport }).then(function () {
                                var image = document.getElementById('image');
                                image.src = canvas.toDataURL();
                            });
                        });
                    });
                });
            }
        }
    }),
    beforeCreate: function beforeCreate() {},
    created: function created() {},
    beforeMount: function beforeMount() {},
    mounted: function mounted() {},
    beforeUpdate: function beforeUpdate() {},
    updated: function updated() {},
    beforeDestroy: function beforeDestroy() {},
    destroyed: function destroyed() {},

    computed: {},
    watch: {}
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_function__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_variable__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_com_header_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_com_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_com_header_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        comHeader: __WEBPACK_IMPORTED_MODULE_6__components_com_header_vue___default.a
    },
    props: {},
    data: function data() {
        return {
            deleteProjectId: null,
            projects: []
        };
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])(['mutationLoading', 'mutationSelectProject']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actionGetUserData', 'actionUpdateProjects', 'actionDeleteFile', 'actionUpdateLastSignIn', 'actionInitUserData', 'actionDeleteProjectFiles']), {
        loadData: function loadData() {
            var _this = this;

            this.mutationLoading(true);
            this.actionGetUserData().then(function (data) {
                if (!data) {
                    _this.actionInitUserData();
                    _this.mutationLoading(false);
                } else {
                    var projectData = data.hasOwnProperty('projects') ? data.projects : [];
                    var lastSignIn = data.hasOwnProperty('lastSignIn') ? data.lastSignIn : null;

                    var now = new Date();
                    var last = new Date(lastSignIn);
                    if (now.getFullYear() !== last.getFullYear() || now.getMonth() !== last.getMonth()) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__js_function__["b" /* log */])('reset month count');
                        projectData = projectData.map(function (projectObj) {
                            projectObj.monthCount = 0;
                            return projectObj;
                        });
                        _this.actionUpdateProjects({ projectArray: projectData }).then(function () {
                            _this.projects = projectData;
                            _this.mutationLoading(false);
                        });
                    } else {
                        _this.projects = projectData;
                        _this.mutationLoading(false);
                    }

                    _this.actionUpdateLastSignIn();
                }
            });
        },
        toProject: function toProject(project) {
            ga('send', 'event', 'toProject', this.getUser.email);
            this.mutationSelectProject(project);
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                name: 'project',
                params: { id: project.projectId }
            });
        },
        showNewProjectInput: function showNewProjectInput() {
            this.$root.$emit('show::modal', 'newProjectInputModal');
        },
        createNewProject: function createNewProject(projectName) {
            var _this2 = this;

            ga('send', 'event', 'createNewProject', this.getUser.email);
            this.mutationLoading(true);
            var uuidv1 = __webpack_require__(188);
            var newProjectData = {
                projectId: uuidv1(),
                projectName: projectName,
                totalCount: 0,
                monthCount: 0,
                speed: __WEBPACK_IMPORTED_MODULE_5__js_variable__["a" /* default */].defaultSpeed,
                countDownBeats: __WEBPACK_IMPORTED_MODULE_5__js_variable__["a" /* default */].defaultCountDownBeats
            };
            this.projects.push(newProjectData);
            this.actionUpdateProjects({ projectArray: this.projects }).then(function () {
                _this2.mutationLoading(false);
            }).catch(function (err) {
                _this2.mutationLoading(false);
            });
        },
        showDelteModal: function showDelteModal(projectId) {
            this.deleteProjectId = projectId;
            this.$root.$emit('show::modal', 'deleteConfirmModal');
        },
        deleteProject: function deleteProject() {
            var _this3 = this;

            ga('send', 'event', 'deleteProject', this.getUser.email);
            this.mutationLoading(true);
            var deleteProjectObj = this.projects.filter(function (projectObj) {
                return projectObj.projectId === _this3.deleteProjectId;
            })[0];
            this.projects = this.projects.filter(function (projectObj) {
                return projectObj.projectId !== _this3.deleteProjectId;
            });

            var promiseArray = [this.actionUpdateProjects({ projectArray: this.projects })];

            if (deleteProjectObj.hasOwnProperty('images')) {
                deleteProjectObj.images.forEach(function (file) {
                    promiseArray.push(_this3.actionDeleteFile({
                        projectId: _this3.deleteProjectId,
                        file: file
                    }));
                });
            }
            if (deleteProjectObj.hasOwnProperty('record')) {
                deleteProjectObj.record.forEach(function (recordObj) {
                    promiseArray.push(_this3.actionDeleteFile({
                        projectId: _this3.deleteProjectId,
                        file: recordObj.fileName
                    }));
                });
            }
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function () {
                _this3.deleteProjectId = null;
                _this3.mutationLoading(false);
            }).catch(function (err) {
                _this3.mutationLoading(false);
            });
        },
        toggleStar: function toggleStar(projectId) {
            var _this4 = this;

            ga('send', 'event', 'toggleStar', this.getUser.email);
            this.mutationLoading(true);
            this.projects = this.projects.map(function (projectObj) {
                if (projectObj.projectId === projectId) {
                    if (!projectObj.hasOwnProperty('star')) {
                        projectObj.star = true;
                    } else {
                        projectObj.star = !projectObj.star;
                    }
                }
                return projectObj;
            });
            this.actionUpdateProjects({ projectArray: this.projects }).then(function () {
                _this4.mutationLoading(false);
            }).catch(function (err) {
                _this4.mutationLoading(false);
            });
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getUser']), {
        sortProjects: function sortProjects() {
            var resultArray = this.projects.reduce(function (result, projectObj) {
                if (projectObj.hasOwnProperty('star') && projectObj.star) result.star.push(projectObj);else result.unstar.push(projectObj);
                return result;
            }, {
                star: [],
                unstar: []
            });
            return resultArray.star.concat(resultArray.unstar);
        }
    }),
    watch: {},
    beforeCreate: function beforeCreate() {},
    created: function created() {
        this.loadData();
    },
    beforeMount: function beforeMount() {},
    mounted: function mounted() {},
    beforeUpdate: function beforeUpdate() {},
    updated: function updated() {},
    beforeDestroy: function beforeDestroy() {},
    destroyed: function destroyed() {}
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cropperjs__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js_function__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_variable__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_com_header_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_com_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_com_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_com_progress_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_com_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_com_progress_vue__);















var that = void 0;
function keydownEvent(e) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('keydown event');
    switch (e.keyCode) {
        case 13:
            if (that.cropper) that.cutImg();
            break;
        case 27:
            if (that.cropper) that.cropper.destroy();
            break;
        case 32:
            if (that.currentStatus === 'play' && that.playStatus === 'playing') that.pause();else if (that.currentStatus === 'play' && that.playStatus === 'pause') that.reply();
            break;
        case 37:
            if (that.currentStatus === 'play' && that.playStatus === 'playing') that.prevPage();
            break;
        case 39:
            if (that.currentStatus === 'play' && that.playStatus === 'playing') that.nextPage();
            break;
    }
}

function dbclickEvent(e) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('dblclick event');
    if (that.cropper && e.target.classList.contains('cropper-move')) that.cutImg();
}
/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        comHeader: __WEBPACK_IMPORTED_MODULE_10__components_com_header_vue___default.a,
        comProgress: __WEBPACK_IMPORTED_MODULE_11__components_com_progress_vue___default.a
    },
    data: function data() {
        return {
            headerLinks: ['hotkey', 'list'],
            currentStatus: 'preview',
            selectProject: {
                projectId: null,
                projectName: null,
                record: [],
                images: []
            },
            beatPerLine: __WEBPACK_IMPORTED_MODULE_9__js_variable__["a" /* default */].defaultBeatPerline,
            playSpeed: __WEBPACK_IMPORTED_MODULE_9__js_variable__["a" /* default */].defaultSpeed,
            projectImgs: [],
            recordImgs: [],
            deleteFileName: null,
            cropper: null,

            playStatus: 'pause',
            playingPage: null,
            playingBeat: 0,
            timer: null,
            playCountCheck: null,
            uploadFileTypeCheckAlert: null
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['getUser', 'getSelectProject', 'getProgress']), {
        haveImageFile: function haveImageFile() {
            return this.getSelectProject && this.getSelectProject.hasOwnProperty('images') && this.getSelectProject.images.length > 0;
        },
        haveRecord: function haveRecord() {
            return this.getSelectProject && this.getSelectProject.hasOwnProperty('record') && this.getSelectProject.record.length > 0;
        },
        playingRecordObj: function playingRecordObj() {
            if (this.haveRecord) {
                if (this.playingPage >= this.getSelectProject.record.length) {
                    return this.getSelectProject.record[this.playingPage - 1];
                } else {
                    return this.getSelectProject.record[this.playingPage];
                }
            } else {
                return {
                    fileName: null,
                    Beat: null
                };
            }
        }
    }),
    watch: {
        playStatus: function playStatus(newStatus) {
            var _this = this;

            if (newStatus === 'playing') {
                var intetvalSecond = 60 / parseInt(this.playSpeed, 10) * 1000;
                this.timer = setInterval(function () {
                    _this.playingBeat += 1;
                    _this.checkChangePage();
                }, intetvalSecond);
            } else if (newStatus === 'pause') {
                clearInterval(this.timer);
            }
        },
        playingPage: function playingPage(newPage) {
            var _this2 = this;

            if (newPage === 0) this.playCountCheck = 'start';
            if (this.playCountCheck === 'start') {
                var countRule = 0.9;
                var playingPagePercentage = (newPage + 1) / this.getSelectProject.record.length;
                if (playingPagePercentage > countRule) {
                    this.playCountCheck = null;
                    var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
                    newProjectObj.totalCount += 1;
                    newProjectObj.monthCount += 1;
                    this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                        _this2.mutationLoading(false);
                    });
                }
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapMutations */])(['mutationLoading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['actionGetImageUrls', 'actionUploadFile', 'actionUpdateSingleProject', 'actionGetSingleImageUrl', 'actionDeleteFile', 'actionGetProjectData', 'actionUploadFileByBase64', 'actionUploadPdfFile']), {
        createImgSrc: function createImgSrc() {
            var _this3 = this;

            if (this.haveImageFile) {
                var promiseArray = [this.actionGetImageUrls({
                    fileArray: this.getSelectProject.images
                })];

                if (this.haveRecord) {
                    promiseArray.push(this.actionGetImageUrls({
                        fileArray: this.getSelectProject.record.map(function (recordObj) {
                            return recordObj.fileName;
                        })
                    }));
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function (result) {
                    if (result.length > 1) {
                        _this3.recordImgs = result[1].map(function (src, index) {
                            return {
                                fileName: _this3.getSelectProject.record[index].fileName,
                                beats: _this3.getSelectProject.record[index].beats,
                                src: src
                            };
                        });
                    }
                    _this3.projectImgs = result[0].map(function (src, index) {
                        return {
                            fileName: _this3.getSelectProject.images[index],
                            src: src
                        };
                    });
                    _this3.mutationLoading(false);
                });
            } else {
                this.mutationLoading(false);
            }
        },
        showUploadModal: function showUploadModal() {
            this.$root.$emit('show::modal', 'uploadModal');
        },
        uploadFile: function uploadFile(e) {
            var _this4 = this;

            ga('send', 'event', 'uploadFile', this.getUser.email);
            var inputFiles = e.target.files || e.dataTransfer.files;
            if (inputFiles.length) {
                var files = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(inputFiles);

                var fileType = files.reduce(function (typeObj, file) {
                    var ext = file.type.replace(/.*\//, '').toLowerCase();
                    if (['jpg', 'jpeg', 'png'].indexOf(ext) > -1) typeObj.image += 1;else if (['pdf'].indexOf(ext) > -1) typeObj.pdf += 1;else typeObj.noSupport += 1;
                    var fileSize = file.size;
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('size', fileSize);
                    if (fileSize > __WEBPACK_IMPORTED_MODULE_9__js_variable__["a" /* default */].uploadFileMaxByte) typeObj.overUploadLimit = true;
                    return typeObj;
                }, {
                    image: 0,
                    pdf: 0,
                    noSupport: 0,
                    overUploadLimit: false
                });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('uploadFileCheck', fileType);

                if (fileType.noSupport) {
                    this.uploadFileTypeCheckAlert = '請使用 PNG、JPG 或 PDF 檔上傳';
                    this.$root.$emit('hide::modal', 'uploadModal');
                    this.$root.$emit('show::modal', 'uploadFileTypeModal');
                } else if (fileType.overUploadLimit) {
                    this.uploadFileTypeCheckAlert = '\u4E0A\u50B3\u6A94\u6848\u8ACB\u52FF\u8D85\u904E ' + __WEBPACK_IMPORTED_MODULE_9__js_variable__["a" /* default */].uploadFileMaxByte / 1000 / 1000 + 'MB';
                    this.$root.$emit('hide::modal', 'uploadModal');
                    this.$root.$emit('show::modal', 'uploadFileTypeModal');
                } else {
                    var promiseArray = [];
                    files.forEach(function (file, index) {
                        var ext = file.type.replace(/.*\//, '').toLowerCase();
                        if (ext === 'pdf') {
                            promiseArray.push(_this4.actionUploadPdfFile({
                                file: file,
                                index: index
                            }));
                        } else {
                            promiseArray.push(_this4.actionUploadFile({
                                file: file,
                                index: index
                            }));
                        }
                    });
                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function (fileArray) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('fileArray', fileArray);

                        _this4.mutationLoading(true);
                        var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this4.getSelectProject));
                        var imageArray = newProjectObj.hasOwnProperty('images') ? newProjectObj.images : [];
                        newProjectObj.images = fileArray.reduce(function (merge, images) {
                            merge = merge.concat(images);
                            return merge;
                        }, imageArray);
                        promiseArray = [_this4.actionUpdateSingleProject({ newProjectObj: newProjectObj }), _this4.actionGetImageUrls({
                            fileArray: newProjectObj.images
                        })];
                        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function (result) {
                            var srcArray = result[1];
                            _this4.projectImgs = srcArray.map(function (src, index) {
                                return {
                                    fileName: _this4.getSelectProject.images[index],
                                    src: src
                                };
                            });
                            document.querySelector('.uploadInput').value = '';
                            _this4.$root.$emit('hide::modal', 'uploadModal');
                            _this4.mutationLoading(false);
                        });
                    });
                }
            };
        },
        moveFileUp: function moveFileUp(fileName) {
            var _this5 = this;

            ga('send', 'event', 'moveFileUp', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.images = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["c" /* arrayElementMoveBackword */])(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this5.projectImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this5.projectImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["c" /* arrayElementMoveBackword */])(_this5.projectImgs, index);
                _this5.mutationLoading(false);
            });
        },
        moveFileDown: function moveFileDown(fileName) {
            var _this6 = this;

            ga('send', 'event', 'moveFileDown', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.images = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["d" /* arrayElementMoveForward */])(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this6.projectImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this6.projectImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["d" /* arrayElementMoveForward */])(_this6.projectImgs, index);
                _this6.mutationLoading(false);
            });
        },
        moveFilBegin: function moveFilBegin(fileName) {
            var _this7 = this;

            ga('send', 'event', 'moveFilBegin', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.images = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["e" /* arrayElementMoveBegin */])(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this7.projectImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this7.projectImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["e" /* arrayElementMoveBegin */])(_this7.projectImgs, index);
                _this7.mutationLoading(false);
            });
        },
        moveFileEnd: function moveFileEnd(fileName) {
            var _this8 = this;

            ga('send', 'event', 'moveFileEnd', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.images = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["f" /* arrayElementMoveEnd */])(newProjectObj.images, newProjectObj.images.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this8.projectImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this8.projectImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["f" /* arrayElementMoveEnd */])(_this8.projectImgs, index);
                _this8.mutationLoading(false);
            });
        },
        showDeleteFileModal: function showDeleteFileModal(fileName) {
            this.deleteFileName = fileName;
            this.$root.$emit('show::modal', 'confirmDeleteModal');
        },
        deleteFile: function deleteFile() {
            var _this9 = this;

            ga('send', 'event', 'deleteFile', this.getUser.email);
            this.mutationLoading(true);
            this.actionDeleteFile({
                projectId: this.getSelectProject.projectId,
                file: this.deleteFileName
            }).then(function () {
                var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this9.getSelectProject));
                newProjectObj.images = newProjectObj.images.filter(function (fileName) {
                    return fileName !== _this9.deleteFileName;
                });
                _this9.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                    _this9.projectImgs = _this9.projectImgs.filter(function (imgObj) {
                        return imgObj.fileName !== _this9.deleteFileName;
                    });
                    _this9.deleteFileName = null;
                    _this9.mutationLoading(false);
                });
            });
        },
        triggerCutter: function triggerCutter(e) {
            if (this.cropper) this.cropper.destroy();
            var targetImg = e.path[0];
            this.cropper = new __WEBPACK_IMPORTED_MODULE_5_cropperjs___default.a(targetImg, {
                autoCropArea: 0.3,

                zoomable: false,
                zoomOnWheel: false,
                zoomOnTouch: false,
                rotatable: false,
                ready: function ready() {},
                cropmove: function cropmove() {}
            });
        },
        cutImg: function cutImg() {
            var _this10 = this;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('issue cutter');
            function getRoundedCanvas(sourceCanvas) {
                var canvas = document.createElement('canvas');
                canvas.width = sourceCanvas.width;
                canvas.height = sourceCanvas.height;

                var context = canvas.getContext('2d');
                context.imageSmoothingEnabled = true;
                context.drawImage(sourceCanvas, 0, 0, sourceCanvas.width, sourceCanvas.height);
                return canvas;
            }

            this.mutationLoading(true);
            var croppedCanvas = this.cropper.getCroppedCanvas();
            var promiseArray = [];
            var fileName = 'cut_' + Date.now() + '.png';
            promiseArray.push(this.actionUploadFileByBase64({
                fileName: fileName,
                base64: getRoundedCanvas(croppedCanvas).toDataURL().substr(22),
                index: 0
            }));

            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])('newProjectObj', newProjectObj);
            if (newProjectObj.hasOwnProperty('record')) {
                newProjectObj.record.push({
                    fileName: fileName,
                    beats: 0
                });
            } else {
                newProjectObj.record = [{
                    fileName: fileName,
                    beats: 0
                }];
            }
            promiseArray.push(this.actionUpdateSingleProject({ newProjectObj: newProjectObj }));
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function () {
                _this10.actionGetImageUrls({
                    fileArray: newProjectObj.record.map(function (recordObj) {
                        return recordObj.fileName;
                    })
                }).then(function (srcArray) {
                    _this10.recordImgs = srcArray.map(function (src, index) {
                        return {
                            fileName: _this10.getSelectProject.record[index].fileName,
                            beats: _this10.getSelectProject.record[index].beats,
                            src: src
                        };
                    });
                    _this10.mutationLoading(false);
                });
            });
        },
        showDeleteRecordModal: function showDeleteRecordModal(fileName) {
            this.deleteFileName = fileName;
            this.$root.$emit('show::modal', 'confirmDeleteRecordModal');
        },
        deleteRecord: function deleteRecord() {
            var _this11 = this;

            ga('send', 'event', 'deleteRecord', this.getUser.email);
            this.mutationLoading(true);
            this.actionDeleteFile({
                projectId: this.getSelectProject.projectId,
                file: this.deleteFileName
            }).then(function () {
                var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this11.getSelectProject));
                newProjectObj.record = newProjectObj.record.filter(function (obj) {
                    return obj.fileName !== _this11.deleteFileName;
                });
                _this11.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                    _this11.recordImgs = _this11.recordImgs.filter(function (obj) {
                        return obj.fileName !== _this11.deleteFileName;
                    });
                    _this11.deleteFileName = null;
                    _this11.mutationLoading(false);
                });
            }).catch(function () {
                var recordObj = _this11.recordImgs.filter(function (obj) {
                    return obj.fileName === _this11.deleteFileName;
                });
                if (recordObj.length === 1 && !recordObj[0].src) {
                    var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this11.getSelectProject));
                    newProjectObj.record = newProjectObj.record.filter(function (obj) {
                        return obj.fileName !== _this11.deleteFileName;
                    });
                    _this11.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                        _this11.recordImgs = _this11.recordImgs.filter(function (obj) {
                            return obj.fileName !== _this11.deleteFileName;
                        });
                        _this11.deleteFileName = null;
                        _this11.mutationLoading(false);
                    });
                } else {
                    _this11.mutationLoading(false);
                }
            });
        },
        moveRecordUp: function moveRecordUp(fileName) {
            var _this12 = this;

            ga('send', 'event', 'moveRecordUp', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["c" /* arrayElementMoveBackword */])(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this12.recordImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this12.recordImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["c" /* arrayElementMoveBackword */])(_this12.recordImgs, index);
                _this12.mutationLoading(false);
            });
        },
        moveRecordDown: function moveRecordDown(fileName) {
            var _this13 = this;

            ga('send', 'event', 'moveRecordDown', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["d" /* arrayElementMoveForward */])(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this13.recordImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this13.recordImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["d" /* arrayElementMoveForward */])(_this13.recordImgs, index);
                _this13.mutationLoading(false);
            });
        },
        moveRecordBegin: function moveRecordBegin(fileName) {
            var _this14 = this;

            ga('send', 'event', 'moveRecordBegin', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["e" /* arrayElementMoveBegin */])(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])(newProjectObj.record);
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this14.recordImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this14.recordImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["e" /* arrayElementMoveBegin */])(_this14.recordImgs, index);
                _this14.mutationLoading(false);
            });
        },
        moveRecordEnd: function moveRecordEnd(fileName) {
            var _this15 = this;

            ga('send', 'event', 'moveRecordEnd', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["f" /* arrayElementMoveEnd */])(newProjectObj.record, newProjectObj.record.indexOf(fileName));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])(newProjectObj.record);
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(_this15.recordImgs, function (obj) {
                    return obj.fileName === fileName;
                });
                _this15.recordImgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["f" /* arrayElementMoveEnd */])(_this15.recordImgs, index);
                _this15.mutationLoading(false);
            });
        },
        addBeat: function addBeat(index) {
            var _this16 = this;

            ga('send', 'event', 'addBeat', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record[index].beats = parseFloat(newProjectObj.record[index].beats) + 1;
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this16.recordImgs[index].beats = parseFloat(_this16.recordImgs[index].beats) + 1;
                _this16.mutationLoading(false);
            });
        },
        minusBeat: function minusBeat(index) {
            var _this17 = this;

            ga('send', 'event', 'minusBeat', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record[index].beats = parseFloat(newProjectObj.record[index].beats) - 1;
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this17.recordImgs[index].beats = parseFloat(_this17.recordImgs[index].beats) - 1;
                _this17.mutationLoading(false);
            });
        },
        addCountDownBeats: function addCountDownBeats() {
            var _this18 = this;

            ga('send', 'event', 'addCountDownBeats', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.countDownBeats += 1;
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this18.mutationLoading(false);
            });
        },
        minusCountDownBeats: function minusCountDownBeats() {
            var _this19 = this;

            ga('send', 'event', 'minusCountDownBeats', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.countDownBeats = Math.max(0, newProjectObj.countDownBeats - 1);
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this19.mutationLoading(false);
            });
        },
        changeSpeed: function changeSpeed() {
            var _this20 = this;

            ga('send', 'event', 'changeSpeed', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.speed = parseInt(this.playSpeed, 10);
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this20.mutationLoading(false);
            });
        },
        showGenerateRecordModal: function showGenerateRecordModal() {
            this.$root.$emit('show::modal', 'confirmGenerateRecordModal');
        },
        generateRecord: function generateRecord() {
            var _this21 = this;

            ga('send', 'event', 'generateRecord', this.getUser.email);
            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.record = newProjectObj.record.map(function (recordObj) {
                recordObj.beats = parseFloat(_this21.beatPerLine);
                return recordObj;
            });
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this21.recordImgs = _this21.recordImgs.map(function (recordObj) {
                    recordObj.beats = parseFloat(_this21.beatPerLine);
                    return recordObj;
                });
                _this21.mutationLoading(false);
            });
        },
        startPlay: function startPlay() {
            ga('send', 'event', 'startPlay', this.getUser.email);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["g" /* fullScreen */])();
            this.currentStatus = 'play';
            this.playStatus = 'playing';
            this.playingPage = 0;
            this.playingBeat = this.getSelectProject.countDownBeats * -1;
        },
        keepPlay: function keepPlay() {
            ga('send', 'event', 'keepPlay', this.getUser.email);
            this.playStatus = 'playing';
        },
        pause: function pause() {
            ga('send', 'event', 'pause', this.getUser.email);
            this.playStatus = 'pause';
        },
        reply: function reply() {
            ga('send', 'event', 'reply', this.getUser.email);
            this.playingBeat = this.getSelectProject.countDownBeats * -1;
            this.startPlay();
        },
        stop: function stop() {
            ga('send', 'event', 'stop', this.getUser.email);
            this.currentStatus = 'preview';
        },
        toListPage: function toListPage() {
            ga('send', 'event', 'toListPage', this.getUser.email);
            __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
                name: 'list'
            });
        },
        prevPage: function prevPage() {
            ga('send', 'event', 'prevPage', this.getUser.email);
            if (this.playingBeat <= 1) this.playingPage -= 1;
            this.playingBeat = 0;
        },
        nextPage: function nextPage() {
            ga('send', 'event', 'nextPage', this.getUser.email);
            this.playingPage += 1;
            this.playingBeat = 0;
        },
        checkChangePage: function checkChangePage() {
            if (this.playingBeat === this.playingRecordObj.beats) {
                this.playingPage += 1;
                if (this.playingPage < this.getSelectProject.record.length) this.playingBeat = 0;else this.pause();
            }
        }
    }),
    beforeCreate: function beforeCreate() {},
    created: function created() {
        var _this22 = this;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__js_function__["b" /* log */])(this.$route.params.id);
        this.mutationLoading(true);
        if (!this.getSelectProject || this.$route.params.id !== this.getSelectProject.projectId) {
            this.actionGetProjectData({
                projectId: this.$route.params.id
            }).then(function () {
                _this22.createImgSrc();

                _this22.playSpeed = _this22.getSelectProject.speed;
                if (_this22.getSelectProject.hasOwnProperty('record')) {
                    var countBeat = _this22.getSelectProject.record.reduce(function (summary, recordObj) {
                        if (summary.hasOwnProperty(recordObj.beats)) {
                            summary[recordObj.beats] += 1;
                        } else {
                            summary[recordObj.beats] = 1;
                        }
                        if (summary[recordObj.beats] > summary.used) {
                            summary.used = summary[recordObj.beats];
                            summary.maxBeat = recordObj.beats;
                        }
                        return summary;
                    }, {
                        maxBeat: null,
                        used: 0
                    });
                    _this22.beatPerLine = countBeat.maxBeat;
                }
            });
        } else {
            this.createImgSrc();

            this.playSpeed = this.getSelectProject.speed;
            if (this.getSelectProject.hasOwnProperty('record')) {
                var countBeat = this.getSelectProject.record.reduce(function (summary, recordObj) {
                    if (summary.hasOwnProperty(recordObj.beats)) {
                        summary[recordObj.beats] += 1;
                    } else {
                        summary[recordObj.beats] = 1;
                    }
                    if (summary[recordObj.beats] > summary.used) {
                        summary.used = summary[recordObj.beats];
                        summary.maxBeat = recordObj.beats;
                    }
                    return summary;
                }, {
                    maxBeat: null,
                    used: 0
                });
                this.beatPerLine = countBeat.maxBeat;
            }
        }
    },
    beforeMount: function beforeMount() {},
    mounted: function mounted() {
        that = this;
        document.addEventListener('keydown', keydownEvent);
        document.querySelector('.previewImgs').addEventListener('dblclick', dbclickEvent);
    },
    beforeUpdate: function beforeUpdate() {},
    updated: function updated() {},
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('keydown', keydownEvent);
        document.querySelector('.previewImgs').removeEventListener('dblclick', dbclickEvent);
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_function__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["actionSignUp", "actionGoogleSignUp"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(["mutationLoading"]), {
    handleFacebookSignIn: function handleFacebookSignIn() {
      var _this = this;

      ga("send", "event", "signInByFacebook", this.getUser.email);
      this.mutationLoading(true);
      this.actionSignUp().then(function (result) {
        _this.mutationLoading(false);
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          name: "list"
        });
      }).catch(function (err) {
        _this.mutationLoading(false);
        _this.alertMsg = "\u767B\u5165\u5931\u6557: " + err.message;
        _this.$root.$emit("show::modal", "signAlertModal");
      });
    },
    handleGoogleSignIn: function handleGoogleSignIn() {
      var _this2 = this;

      ga("send", "event", "signInByGoogle", this.getUser.email);
      this.mutationLoading(true);
      this.actionGoogleSignUp().then(function (result) {
        _this2.mutationLoading(false);
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          name: "list"
        });
      }).catch(function (err) {
        _this2.mutationLoading(false);
        _this2.alertMsg = "\u767B\u5165\u5931\u6557: " + err.message;
        _this2.$root.$emit("show::modal", "signAlertModal");
      });
    }
  }),
  data: function data() {
    return {
      alertMsg: ""
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUser"])),
  watch: {},
  beforeCreate: function beforeCreate() {},
  created: function created() {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])("User is sign in");
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])("User is not sign in");
      }
    });
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeUpdate: function beforeUpdate() {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {}
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_function__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        links: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        title: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {};
    },
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])(['mutationLoading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actionSignOut', 'actionUpdateSingleProject']), {
        signOut: function signOut() {
            this.$root.$emit('show::modal', 'signOutModal');
        },
        confirmSignOut: function confirmSignOut() {
            var _this = this;

            ga('send', 'event', 'signOut', this.getUser.email);
            this.mutationLoading(true);
            this.actionSignOut().then(function () {
                _this.mutationLoading(false);
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                    name: 'sign'
                });
            });
        },
        showEditTitleModal: function showEditTitleModal() {
            this.$root.$emit('show::modal', 'editTitleModal');
        },
        confirmEditTitle: function confirmEditTitle(newTitle) {
            var _this2 = this;

            this.mutationLoading(true);
            var newProjectObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getSelectProject));
            newProjectObj.projectName = newTitle;
            this.actionUpdateSingleProject({ newProjectObj: newProjectObj }).then(function () {
                _this2.mutationLoading(false);
            });
        },
        toListPage: function toListPage() {
            ga('send', 'event', 'toListPage_header', this.getUser.email);
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
                name: 'list'
            });
        },
        showHotkey: function showHotkey() {
            this.$root.$emit('show::modal', 'hotkeyModal');
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getUser', 'getSelectProject'])),
    watch: {},
    beforeCreate: function beforeCreate() {},
    created: function created() {},
    beforeMount: function beforeMount() {},
    mounted: function mounted() {},
    beforeUpdate: function beforeUpdate() {},
    updated: function updated() {},
    beforeDestroy: function beforeDestroy() {},
    destroyed: function destroyed() {}
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getLoading']))
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_function__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        modalId: {
            type: String,
            default: 'modal'
        },
        modalType: {
            type: String,
            default: 'alert' },
        alertType: {
            type: String,
            default: 'success' },
        title: {
            type: String,
            default: null
        },
        confirmTitle: {
            type: String,
            default: '確認'
        },
        cancelTitle: {
            type: String,
            default: '取消'
        },
        emptyInputAlert: {
            type: String,
            default: '請填入資料'
        },
        defaultInput: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {
            inputValue: '',
            showEmptyAlert: false
        };
    },
    methods: {
        confirm: function confirm(e) {
            if (this.modalType === 'input' && this.inputValue === '') {
                this.showEmptyAlert = true;
                document.querySelector('.inputModal input').focus();
                if (e) return e.cancel();
            } else {
                this.showEmptyAlert = false;
                this.$emit('confirm', this.inputValue);
            }
        },
        confirmByEnter: function confirmByEnter() {
            this.confirm();
            if (this.inputValue) this.$root.$emit('hide::modal', this.modalId);
        },
        cancel: function cancel() {
            this.showEmptyAlert = false;
        },
        focusInput: function focusInput() {
            this.inputValue = this.defaultInput;
            setTimeout(function () {
                document.querySelector('.inputModal input').focus();
            }, 0);
        }
    },
    beforeCreate: function beforeCreate() {},
    created: function created() {},
    beforeMount: function beforeMount() {},
    mounted: function mounted() {},
    beforeUpdate: function beforeUpdate() {},
    updated: function updated() {},
    beforeDestroy: function beforeDestroy() {},
    destroyed: function destroyed() {}
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getProgress']))
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_function__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_variable__ = __webpack_require__(29);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('com-loading', __webpack_require__(83));
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('com-modal', __webpack_require__(84));

firebase.initializeApp(__WEBPACK_IMPORTED_MODULE_5__js_variable__["a" /* default */].firebaseConfig);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
    inserted: function inserted(el) {
        el.focus();
    }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */]
});

(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-63053452-15', 'auto');
ga('send', 'pageview');

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionSignUp", function() { return actionSignUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGoogleSignUp", function() { return actionGoogleSignUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionSignOut", function() { return actionSignOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGetUserData", function() { return actionGetUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGetLastSingIn", function() { return actionGetLastSingIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGetProjectsData", function() { return actionGetProjectsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGetProjectData", function() { return actionGetProjectData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionInitUserData", function() { return actionInitUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionUpdateLastSignIn", function() { return actionUpdateLastSignIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionUpdateProjects", function() { return actionUpdateProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionUpdateSingleProject", function() { return actionUpdateSingleProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionDeleteFile", function() { return actionDeleteFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGetImageUrls", function() { return actionGetImageUrls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionGetSingleImageUrl", function() { return actionGetSingleImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionUploadFile", function() { return actionUploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionUploadFileByBase64", function() { return actionUploadFileByBase64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionUploadPdfFile", function() { return actionUploadPdfFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_function__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfjs_dist__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfjs_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfjs_dist__);






var actionSignUp = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var provider = new firebase.auth.FacebookAuthProvider();
              firebase.auth().signInWithPopup(provider).then(function (result) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('fb signup success', result);
                commit('mutationUser', {
                  uid: result.user.uid,
                  email: result.user.email,
                  displayName: result.user.displayName
                });
                resolve(result);
              }).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] fb signup', err);
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function actionSignUp(_x) {
    return _ref.apply(this, arguments);
  };
}();

var actionGoogleSignUp = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var provider = new firebase.auth.GoogleAuthProvider();
              firebase.auth().signInWithPopup(provider).then(function (result) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('google signup success', result);
                commit('mutationUser', {
                  uid: result.user.uid,
                  email: result.user.email,
                  displayName: result.user.displayName
                });
                resolve(result);
              }).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] google signup', err);
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function actionGoogleSignUp(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var actionSignOut = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              firebase.auth().signOut().catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] signout', err);
                reject(err);
              });
              resolve();
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function actionSignOut() {
    return _ref5.apply(this, arguments);
  };
}();

var actionGetUserData = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                  firebase.database().ref('users/' + user.uid).once('value', function (snapshot) {
                    resolve(snapshot.val());
                  });
                } else {
                  reject({
                    code: '',
                    message: 'account is not sign in'
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function actionGetUserData() {
    return _ref6.apply(this, arguments);
  };
}();

var actionGetLastSingIn = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                  firebase.database().ref('users/' + user.uid + '/lastSignIn').once('value', function (snapshot) {
                    resolve(snapshot.val());
                  });
                } else {
                  reject({
                    code: '',
                    message: 'account is not sign in'
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function actionGetLastSingIn() {
    return _ref7.apply(this, arguments);
  };
}();

var actionGetProjectsData = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                  firebase.database().ref('users/' + user.uid + '/projects').once('value', function (snapshot) {
                    resolve(snapshot.val());
                  });
                } else {
                  reject({
                    code: '',
                    message: 'account is not sign in'
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function actionGetProjectsData() {
    return _ref8.apply(this, arguments);
  };
}();

var actionGetProjectData = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref10, _ref11) {
    var getters = _ref10.getters,
        commit = _ref10.commit;
    var projectId = _ref11.projectId;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                  firebase.database().ref('users/' + user.uid + '/projects').once('value', function (snapshot) {
                    var projectObj = snapshot.val().reduce(function (result, obj) {
                      if (obj.projectId === projectId) result = obj;
                      return result;
                    }, '');
                    if (projectObj) {
                      commit('mutationSelectProject', projectObj);
                      resolve(projectObj);
                    } else {
                      reject({
                        code: '',
                        message: 'no match project: ' + projectId
                      });
                    }
                  });
                } else {
                  reject({
                    code: '',
                    message: 'account is not sign in'
                  });
                }
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function actionGetProjectData(_x3, _x4) {
    return _ref9.apply(this, arguments);
  };
}();

var actionInitUserData = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref13) {
    var getters = _ref13.getters;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;
              var userData = {
                account: user.email,
                name: user.displayName,
                lastSignIn: Date.now()
              };
              firebase.database().ref('users/' + user.uid).set(userData).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionInitUserData', err);
                reject(err);
              });
              resolve();
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function actionInitUserData(_x5) {
    return _ref12.apply(this, arguments);
  };
}();

var actionUpdateLastSignIn = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(_ref15) {
    var getters = _ref15.getters;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;
              var now = Date.now();
              firebase.database().ref('users/' + user.uid + '/lastSignIn').set(now).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUpdateLastSignIn', err);
                reject(err);
              });
              resolve();
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function actionUpdateLastSignIn(_x6) {
    return _ref14.apply(this, arguments);
  };
}();

var actionUpdateProjects = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(_ref17, _ref18) {
    var getters = _ref17.getters;
    var projectArray = _ref18.projectArray;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;

              firebase.database().ref('users/' + user.uid + '/projects').set(projectArray).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUpdateProjects', err);
                reject(err);
              });
              resolve();
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function actionUpdateProjects(_x7, _x8) {
    return _ref16.apply(this, arguments);
  };
}();

var actionUpdateSingleProject = function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(_ref20, _ref21) {
    var commit = _ref20.commit,
        getters = _ref20.getters;
    var newProjectObj = _ref21.newProjectObj;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              commit('mutationSelectProject', newProjectObj);
              var user = getters.getUser;
              firebase.database().ref('users/' + user.uid + '/projects').once('value', function (snapshot) {
                var projectArray = snapshot.val();
                projectArray = projectArray.map(function (oriProjectObj) {
                  if (oriProjectObj.projectId === newProjectObj.projectId) return newProjectObj;
                  return oriProjectObj;
                });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('actionUpdateSingleProject', projectArray);
                firebase.database().ref('users/' + user.uid + '/projects').set(projectArray).catch(function (err) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUpdateSingleProject', err);
                  reject(err);
                });
                resolve();
              });
            }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function actionUpdateSingleProject(_x9, _x10) {
    return _ref19.apply(this, arguments);
  };
}();

var actionDeleteFile = function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(_ref23, _ref24) {
    var getters = _ref23.getters;
    var projectId = _ref24.projectId,
        file = _ref24.file;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('actionDeleteFile', file);
              var user = getters.getUser;
              firebase.storage().ref().child(user.uid + '/' + projectId + '/' + file).delete().then(function () {
                return resolve();
              }).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionDeleteFile', err);
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function actionDeleteFile(_x11, _x12) {
    return _ref22.apply(this, arguments);
  };
}();

function getSingleImageUrl(_ref25) {
  var uid = _ref25.uid,
      projectId = _ref25.projectId,
      img = _ref25.img;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var tempShareAccounts = ['NOs2cA7dIAW2ZVzvwryMq7C9sat2', 'uIm1cREeO1eqsApZQKgohSfRPF42'];
    var modifyUid = tempShareAccounts.indexOf(uid) > -1 ? 'B9opRU9ccXVPjCsOvBfxOECulFF2' : uid;
    console.log('modifyUid', modifyUid);
    firebase.storage().ref().child(modifyUid + '/' + projectId + '/' + img).getDownloadURL().then(function (url) {
      resolve(url);
    }).catch(function (err) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] getSingleImageUrl', err);
      resolve(null);
    });
  });
}

var actionGetImageUrls = function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(_ref27, _ref28) {
    var getters = _ref27.getters;
    var fileArray = _ref28.fileArray;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('actionGetImageUrls', fileArray);
              var user = getters.getUser;
              var project = getters.getSelectProject;
              var promiseArray = fileArray.map(function (img) {
                return getSingleImageUrl({
                  uid: user.uid,
                  projectId: project.projectId,
                  img: img
                });
              });
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promiseArray).then(function (urlArray) {
                resolve(urlArray);
              }).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionGetImageUrls', err);
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function actionGetImageUrls(_x13, _x14) {
    return _ref26.apply(this, arguments);
  };
}();

var actionGetSingleImageUrl = function () {
  var _ref29 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(_ref30, _ref31) {
    var getters = _ref30.getters;
    var fileName = _ref31.fileName;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;
              var project = getters.getSelectProject;

              firebase.storage().ref().child(user.uid + '/' + project.projectId + '/' + fileName).getDownloadURL().then(function (url) {
                resolve(url);
              }).catch(function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionGetSingleImageUrl', err);
                reject(err);
              });
            }));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function actionGetSingleImageUrl(_x15, _x16) {
    return _ref29.apply(this, arguments);
  };
}();

var actionUploadFile = function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(_ref33, _ref34) {
    var commit = _ref33.commit,
        getters = _ref33.getters;
    var file = _ref34.file,
        index = _ref34.index;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;
              var project = getters.getSelectProject;
              var progressArray = getters.getProgressArray;
              var fileName = '' + Date.now() + index + '.' + file.type.replace(/.*\//, '');
              firebase.storage().ref().child(user.uid + '/' + project.projectId + '/' + fileName).put(file).on('state_changed', function (snapshot) {
                progressArray[index] = Math.ceil(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                var value = progressArray.reduce(function (sum, val) {
                  sum += val;
                  return sum;
                }, 0) / progressArray.length;
                commit('mutationProgressArray', progressArray);
                commit('mutationProgress', value);
              }, function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUploadFile', err);
                reject(err);
              }, function () {
                resolve([fileName]);
              });
            }));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function actionUploadFile(_x17, _x18) {
    return _ref32.apply(this, arguments);
  };
}();

var actionUploadFileByBase64 = function () {
  var _ref35 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(_ref36, _ref37) {
    var commit = _ref36.commit,
        getters = _ref36.getters;
    var base64 = _ref37.base64,
        fileName = _ref37.fileName,
        index = _ref37.index;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('actionUploadFileByBase64', fileName, index);
            return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;
              var project = getters.getSelectProject;
              var progressArray = getters.getProgressArray;

              firebase.storage().ref().child(user.uid + '/' + project.projectId + '/' + fileName).putString(base64, 'base64').on('state_changed', function (snapshot) {
                progressArray[index] = Math.ceil(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                var value = progressArray.reduce(function (sum, val) {
                  sum += val;
                  return sum;
                }, 0) / progressArray.length;
                commit('mutationProgressArray', progressArray);
                commit('mutationProgress', value);
              }, function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUploadFileByBase64', err);
                reject(err);
              }, function () {
                resolve();
              });
            }));

          case 2:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function actionUploadFileByBase64(_x19, _x20) {
    return _ref35.apply(this, arguments);
  };
}();

var actionUploadPdfFile = function () {
  var _ref38 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(_ref39, _ref40) {
    var commit = _ref39.commit,
        getters = _ref39.getters;
    var file = _ref40.file,
        index = _ref40.index;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('actionUploadPdfFile', file, index);
            return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var user = getters.getUser;
              var progressArray = getters.getProgressArray;
              firebase.storage().ref().child(user.uid + '/temp' + index + '.pdf').put(file).on('state_changed', function (snapshot) {
                progressArray[0] = Math.ceil(snapshot.bytesTransferred / snapshot.totalBytes * 100);
                var value = progressArray.reduce(function (sum, val) {
                  sum += val;
                  return sum;
                }, 0) / progressArray.length;
                commit('mutationProgressArray', progressArray);
                commit('mutationProgress', value);
              }, function (err) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUploadPdfFile', err);
                reject(err);
              }, function () {
                firebase.storage().ref().child(user.uid + '/temp' + index + '.pdf').getDownloadURL().then(function (url) {
                  __WEBPACK_IMPORTED_MODULE_4_pdfjs_dist___default.a.disableWorker = true;
                  __WEBPACK_IMPORTED_MODULE_4_pdfjs_dist___default.a.getDocument(url).then(function (pdf) {
                    var imageArray = [];
                    var uploadPage = 0;

                    var _loop = function _loop(i) {
                      var fileName = '' + Date.now() + index + i + '.png';
                      imageArray.push(fileName);
                      pdf.getPage(i + 1).then(function (page) {
                        var scale = 1.5;
                        var viewport = page.getViewport(scale);
                        var canvas = document.createElement('canvas');
                        var context = canvas.getContext('2d');
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        page.render({
                          canvasContext: context,
                          viewport: viewport
                        }).then(function () {
                          actionUploadFileByBase64({
                            commit: commit,
                            getters: getters
                          }, {
                            fileName: fileName,
                            base64: canvas.toDataURL().substr(22),
                            index: 0
                          }).then(function () {
                            uploadPage += 1;
                            if (uploadPage === pdf.numPages) resolve(imageArray);
                          });
                        });
                      });
                    };

                    for (var i = 0; i < pdf.numPages; i += 1) {
                      _loop(i);
                    }
                  });
                }).catch(function (err) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__js_function__["b" /* log */])('[ERR] actionUploadPdfFile', err);
                  reject(err);
                });
              });
            }));

          case 2:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function actionUploadPdfFile(_x21, _x22) {
    return _ref38.apply(this, arguments);
  };
}();

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLoading", function() { return getLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectProject", function() { return getSelectProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProgress", function() { return getProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProgressArray", function() { return getProgressArray; });
var getUser = function getUser(state) {
  return state.user;
};
var getLoading = function getLoading(state) {
  return state.loading;
};
var getSelectProject = function getSelectProject(state) {
  return state.selectProject;
};
var getProgress = function getProgress(state) {
  return state.progress;
};
var getProgressArray = function getProgressArray(state) {
  return state.progressArray;
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutationUser", function() { return mutationUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutationLoading", function() { return mutationLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutationSelectProject", function() { return mutationSelectProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutationProgress", function() { return mutationProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutationProgressArray", function() { return mutationProgressArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var mutationUser = function mutationUser(state, value) {
    state.user = value;
    window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
};
var mutationLoading = function mutationLoading(state, value) {
    state.loading = value;
};
var mutationSelectProject = function mutationSelectProject(state, value) {
    state.selectProject = value;
    window.localStorage.setItem('selectProject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
};
var mutationProgress = function mutationProgress(state, value) {
    state.progress = value;
};
var mutationProgressArray = function mutationProgressArray(state, value) {
    state.progressArray = value;
};

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.1aa9423.gif";

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(152)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.getLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(182),
      "alt": "載入中"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appSign"
    }
  }, [_c('com-loading'), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(77),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "signInGroup",
    on: {
      "click": _vm.handleGoogleSignIn
    }
  }, [_c('span', {
    staticClass: "signInTitle"
  }, [_vm._v("Google 登入/註冊")])]), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "alert",
      "alertType": "fail",
      "modalId": "signAlertModal",
      "title": _vm.alertMsg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appList"
    }
  }, [_c('com-loading'), _vm._v(" "), _c('com-header'), _vm._v(" "), _c('div', {
    staticClass: "main floatBotOuter"
  }, [_vm._l((_vm.sortProjects), function(projectObj) {
    return _c('div', {
      key: projectObj.projectId,
      staticClass: "floatBox",
      on: {
        "click": function($event) {
          return _vm.toProject(projectObj)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(projectObj.projectName))]), _vm._v(" "), _c('div', {
      staticClass: "count"
    }, [_vm._v(_vm._s(projectObj.monthCount) + "/" + _vm._s(projectObj.totalCount))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times deleteBtn",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDelteModal(projectObj.projectId)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa startBtn",
      class: {
        'fa-star-o': !projectObj.hasOwnProperty('star') || !projectObj.star, 'fa-star': projectObj.hasOwnProperty('star') && projectObj.star
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleStar(projectObj.projectId)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "project floatBox",
    on: {
      "click": _vm.showNewProjectInput
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "input",
      "modalId": "newProjectInputModal",
      "title": "請輸入歌曲名稱",
      "ok-title": "新建",
      "emptyInputAlert": "歌曲名稱請勿空白"
    },
    on: {
      "confirm": _vm.createNewProject
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "deleteConfirmModal",
      "title": "確認刪除此歌曲? (已上傳樂譜將同步刪除)"
    },
    on: {
      "confirm": _vm.deleteProject
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comModal"
  }, [(_vm.modalType === 'input') ? _c('b-modal', {
    staticClass: "inputModal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "close-title": _vm.cancelTitle,
      "ok-title": _vm.confirmTitle
    },
    on: {
      "ok": _vm.confirm,
      "cancel": _vm.cancel,
      "shown": _vm.focusInput
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmByEnter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.showEmptyAlert,
      "variant": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.emptyInputAlert))])], 1) : (_vm.modalType === 'alert') ? _c('b-modal', {
    staticClass: "alertModal",
    class: _vm.alertType,
    attrs: {
      "id": _vm.modalId,
      "title": "",
      "hide-footer": ""
    },
    on: {
      "ok": function($event) {
        return _vm.confirm()
      }
    }
  }, [(_vm.alertType === 'fail') ? _c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : (_vm.alertType === 'success') ? _c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.title) + "\n    ")]) : (_vm.modalType === 'confirm') ? _c('b-modal', {
    staticClass: "confirmModal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "close-title": _vm.cancelTitle,
      "ok-title": _vm.confirmTitle
    },
    on: {
      "ok": function($event) {
        return _vm.confirm()
      }
    }
  }) : (_vm.modalType === 'preview') ? _c('b-modal', {
    staticClass: "previewModal",
    attrs: {
      "id": _vm.modalId,
      "title": "",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._t("modalContent")], 2) : (_vm.modalType === 'modal') ? _c('b-modal', {
    staticClass: "originalModal",
    attrs: {
      "id": _vm.modalId,
      "title": _vm.title,
      "close-title": _vm.cancelTitle,
      "ok-title": _vm.confirmTitle
    },
    on: {
      "ok": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._t("modalContent")], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "comHeader"
    }
  }, [_c('img', {
    staticClass: "iconImg",
    attrs: {
      "src": __webpack_require__(77),
      "alt": "icon"
    }
  }), _vm._v(" "), (_vm.title !== null) ? _c('p', {
    staticClass: "title",
    on: {
      "click": _vm.showEditTitleModal
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(_vm.links.indexOf('hotkey') > -1) ? _c('div', {
    staticClass: "link hotkey",
    on: {
      "click": _vm.showHotkey
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.links.indexOf('list') > -1) ? _c('div', {
    staticClass: "link toListBtn",
    on: {
      "click": _vm.toListPage
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link signOutBtn",
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "signOutModal",
      "title": "確認登出?"
    },
    on: {
      "confirm": _vm.confirmSignOut
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "input",
      "modalId": "editTitleModal",
      "title": "請輸入歌曲名稱",
      "ok-title": "更新",
      "emptyInputAlert": "歌曲名稱請勿空白",
      "defaultInput": _vm.title
    },
    on: {
      "confirm": _vm.confirmEditTitle
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "preview",
      "modalId": "hotkeyModal"
    }
  }, [_c('div', {
    staticClass: "hotkeyIntro",
    attrs: {
      "slot": "modalContent"
    },
    slot: "modalContent"
  }, [_c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("Enter")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("確認複製選取範圍")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("ESC")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("離開圖片複製模式")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("SPACE")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("播放/暫停")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_c('i', {
    staticClass: "fa fa-caret-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("上一頁")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("下一頁")])])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appProject"
    }
  }, [_c('com-loading'), _vm._v(" "), _c('com-progress'), _vm._v(" "), (_vm.currentStatus === 'preview') ? _c('com-header', {
    attrs: {
      "links": _vm.headerLinks,
      "title": _vm.getSelectProject.projectName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStatus === 'preview') ? _c('div', {
    staticClass: "main preview"
  }, [_c('div', {
    staticClass: "edit"
  }, [(_vm.haveRecord) ? _c('div', {
    staticClass: "editControlBtns"
  }, [_c('div', {
    attrs: {
      "title": "每行拍子數"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beatPerLine),
      expression: "beatPerLine"
    }],
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.beatPerLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beatPerLine = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-level-down",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showGenerateRecordModal()
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "節拍器速度"
    }
  }, [_c('i', {
    staticClass: "fa fa-music",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playSpeed),
      expression: "playSpeed"
    }],
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.playSpeed)
    },
    on: {
      "change": _vm.changeSpeed,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playSpeed = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgDiv countDownSetting"
  }, [_c('div', {
    staticClass: "editBtns"
  }, [_c('span', [_vm._v("倒數拍數")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getSelectProject.countDownBeats))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCountDownBeats()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.minusCountDownBeats()
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.recordImgs), function(recordImgObj, index) {
    return _c('div', {
      key: index,
      staticClass: "imgDiv"
    }, [_c('div', {
      staticClass: "editBtns"
    }, [_c('span', [_vm._v("P" + _vm._s(index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(recordImgObj.beats))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addBeat(index)
        }
      }
    }), _vm._v(" "), (recordImgObj.beats > 0) ? _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.minusBeat(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "controlBtns"
    }, [(index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up borderTop",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordBegin(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.getSelectProject.record.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down borderBottom",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordEnd(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordUp(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.getSelectProject.record.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordDown(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times deleteBtn",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDeleteRecordModal(recordImgObj.fileName)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "src": recordImgObj.src
      }
    })])
  }), _vm._v(" "), (_vm.haveRecord) ? _c('div', {
    staticClass: "circleBtn playBtn"
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.startPlay
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [(!_vm.haveImageFile) ? _c('div', {
    staticClass: "uploadDiv"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("請將樂譜檔案拖曳至此進行上傳")]), _vm._v(" "), _c('input', {
    staticClass: "uploadInput",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "previewImgs"
  }, _vm._l((_vm.projectImgs), function(imgObj, index) {
    return _c('div', {
      key: index,
      staticClass: "imgDiv"
    }, [_c('div', {
      staticClass: "page"
    }, [_c('span', [_vm._v("P" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "controlBtns"
    }, [(index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up borderTop",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFilBegin(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.projectImgs.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down borderBottom",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFileEnd(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFileUp(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.projectImgs.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFileDown(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times deleteBtn",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDeleteFileModal(imgObj.fileName)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "src": imgObj.src
      },
      on: {
        "click": _vm.triggerCutter
      }
    })])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "circleBtn uploadBtn",
    on: {
      "click": _vm.showUploadModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "preview",
      "modalId": "uploadModal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modalContent"
    },
    slot: "modalContent"
  }, [_c('div', {
    staticClass: "uploadDiv"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("請將樂譜檔案拖曳至此進行上傳")]), _vm._v(" "), _c('input', {
    staticClass: "uploadInput",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadFile
    }
  })])])]), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "confirmDeleteModal",
      "title": "確認刪除該頁樂譜?"
    },
    on: {
      "confirm": _vm.deleteFile
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "confirmDeleteRecordModal",
      "title": "確認刪除此筆記錄?"
    },
    on: {
      "confirm": _vm.deleteRecord
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "confirmGenerateRecordModal",
      "title": "確認更新所有頁面節拍數?"
    },
    on: {
      "confirm": _vm.generateRecord
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalTpye": "alert",
      "alertType": "fail",
      "modalId": "uploadFileTypeModal",
      "title": _vm.uploadFileTypeCheckAlert
    }
  }), _vm._v(" "), (_vm.currentStatus === 'play') ? _c('div', {
    staticClass: "play"
  }, [_c('div', {
    staticClass: "progressDiv"
  }, [_c('div', {
    staticClass: "progressBar"
  }, [_c('b-progress', {
    attrs: {
      "max": _vm.playingRecordObj.beats,
      "precision": 1
    },
    model: {
      value: (_vm.playingBeat),
      callback: function($$v) {
        _vm.playingBeat = $$v
      },
      expression: "playingBeat"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "playingContent"
  }, [_c('div', {
    staticClass: "imgDiv countDownDiv",
    class: {
      hide: 0 <= _vm.playingBeat
    }
  }, _vm._l((_vm.getSelectProject.countDownBeats), function(beat, index) {
    return _c('span', {
      key: index,
      staticClass: "countDownAnimate",
      class: {
        active: index < (_vm.playingBeat + _vm.getSelectProject.countDownBeats)
      }
    }, [_vm._v("\n                    " + _vm._s(beat) + "\n                ")])
  }), 0), _vm._v(" "), _vm._l((_vm.recordImgs), function(recordObj, index) {
    return _c('div', {
      key: index,
      staticClass: "imgDiv",
      class: {
        hide: index < _vm.playingPage
      }
    }, [_c('img', {
      attrs: {
        "src": recordObj.src
      }
    })])
  })], 2), _vm._v(" "), (_vm.playingPage > 0) ? _c('div', {
    staticClass: "prevBtn",
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.playingPage < _vm.recordImgs.length - 1) ? _c('div', {
    staticClass: "nextBtn",
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "circleBtn pauseBtn"
  }, [_c('i', {
    staticClass: "fa fa-pause",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pause.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pageNum"
  }, [_vm._v("\n            " + _vm._s(_vm.playingPage + 1) + " / " + _vm._s(_vm.recordImgs.length) + "\n        ")]), _vm._v(" "), (_vm.playStatus === 'pause') ? _c('div', {
    staticClass: "pauseScreen"
  }, [(_vm.playingPage > 0) ? _c('div', {
    staticClass: "prevBtn",
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.playingPage < _vm.recordImgs.length - 1) ? _c('div', {
    staticClass: "nextBtn",
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [(_vm.playingBeat !== _vm.playingRecordObj.beats) ? _c('div', {
    staticClass: "circleBtn playBtn"
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.keepPlay
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "circleBtn repeatBtn"
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reply.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circleBtn stopBtn"
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stop.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circleBtn toListBtn",
    on: {
      "click": _vm.toListPage
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getProgress < 100) ? _c('div', {
    staticClass: "comProgress"
  }, [_c('b-progress', {
    attrs: {
      "precision": 1
    },
    model: {
      value: (_vm.getProgress),
      callback: function($$v) {
        _vm.getProgress = $$v
      },
      expression: "getProgress"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "test"
    }
  }, [_c('button', {
    on: {
      "click": _vm.test
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 204 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 205 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 206 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 207 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[93]);


// WEBPACK FOOTER //
// static/js/app.c0a90f8292fde14c3186.js